import React, { useCallback, useState } from 'react';
import { Collapse } from 'reactstrap';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  title: string;
  children: React.ReactNode;
};

export default function Collapsed({ title, children }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  return (
    <div className="d-flex flex-column w-100">
      <div className="d-flex align-items-center py-2 w-100" style={{ cursor: 'pointer' }} onClick={handleClick}>
        {isOpen ? <WpIcon name="chevron-down" /> : <WpIcon name="chevron-right" />}
        <p
          className="text-primary m-0 ml-1 text-uppercase"
          style={{ maxWidth: '100%', overflowX: 'hidden', fontSize: '11px', lineHeight: '147%', fontWeight: 600 }}
        >
          {title}
        </p>
        <button className="btn text-primary p-0" type="button" onClick={handleClick} aria-label="toggle" />
      </div>
      <Collapse isOpen={isOpen}>{children}</Collapse>
    </div>
  );
}
